import React from "react";
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import FolderIcon from '@material-ui/icons/Folder';
import { CreateCSSProperties } from "@material-ui/core/styles/withStyles";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles<CreateCSSProperties>(() => ({
  header: {
    fontSize: "1.2rem",
    fontWeight: 500,
    color: "#475569",
    fontFamily: "'Quicksand', sans-serif",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
    lineHeight: 'normal',
  },

  accordion:{
    paddingLeft: "0.35vw",
    '&.MuiAccordion-root.Mui-expanded':{
      margin: 0,
    },
    '&.MuiPaper-elevation1':{
      boxShadow: "none",
    },
    '&:before':{
      content: "none",
    },
  },

  accordionSummary: {
    backgroundColor: "#FFFFFF",
    flexDirection: "row-reverse",
    paddingLeft: "0.8vw",
    minHeight: "3vh",

    '&.MuiAccordionSummary-root.Mui-expanded':{
      minHeight: "3vh",
    },

    '& .MuiIconButton-root':{
      padding: 0
    },

    "& .MuiButtonBase-root.Mui-expanded": {
      transform: "rotate(90deg)",
    },

    "& .MuiAccordionSummary-content": {
      margin: 0,
      alignItems: "center",
      marginLeft: '1.2vw',
    },
  },

  accordionDetails: {
    fontWeight: 500,
    color: "#475569",
    fontFamily: "'Quicksand', sans-serif",
    "&.MuiAccordionDetails-root": {
      padding: "0.5vh 0 0.5vh 1vw",
    },
  },

  menuItem: {
    "&.MuiMenuItem-root": {
      padding: "0 0 0 1.7vw",
    },
    "&:hover": {
      backgroundColor: "white",
    },
    fontSize: "0.9vw",
    marginBottom: "1.4vh",
  },
}));

const FolderComp = (props: any) => {
  const { folderList, parentFolderId, handleOnFolderClick } = props;
  const classes = useStyles();

  return (
    <>
      {folderList.map((data: any) => (
        <Accordion
          key={data.folderId}
          TransitionProps={{ unmountOnExit: true }}
          className = {classes.accordion}
        >
          <AccordionSummary
            className={classes.accordionSummary}
            expandIcon={
              data.subfolders.length > 0 ? (
                <ArrowForwardIosIcon
                  htmlColor= "#64748B"
                  fontSize = 'small'
                />
              ) : null
            }>
              <div style = {{ display: 'flex', marginRight: '0.4vw' }}>
                <FolderIcon htmlColor="#64748B" />
              </div>
              <span
                onClick={() =>
                  handleOnFolderClick(
                    data
                  )
                }
                className={classes.header}
              >
                {data.name}
              </span>
          </AccordionSummary>
          {data.subfolders.length > 0 ? 
            <FolderComp
            folderList={data.subfolders}
            parentFolderId={`${parentFolderId ? parentFolderId : ""}/${
              data.folderId
            }`}
            handleOnFolderClick = {handleOnFolderClick}
            />
             : null}
        </Accordion>
      ))}
    </>
  );
};

export default FolderComp;



// WEBPACK FOOTER //
// ./src/editor/ui/editor/imageLibrary/FolderComp.tsx